import React from 'react'
import { Skeleton } from 'antd'

import epicStyles from './EpicHeaderRow.module.css'
import sectionStyles from './SprintSection.module.css'
import taskStyles from '../../projectDetail.module.css'
import skStyles from './DevelopmentSprintBoardSkeleton.module.css'

const EPIC_PLACEHOLDER_COUNT = 4
const TASK_LANE_COUNT = 4

/** Matches `epicGridStyle` / `SprintSection` when the board has four epic columns. */
const FOUR_COLUMN_GRID = {
    gridTemplateColumns: 'repeat(4, minmax(252px, 170px))',
}

const DevelopmentSprintBoardSkeleton = () => {
    return (
        <div className={skStyles.root} aria-hidden>
            <div className={epicStyles.epicHeaderRow}>
                <div className={epicStyles.epicRowScroll}>
                    <div
                        className={epicStyles.epicRow}
                        style={FOUR_COLUMN_GRID}
                    >
                        {Array.from({ length: EPIC_PLACEHOLDER_COUNT }).map(
                            (_, i) => (
                                <div
                                    key={i}
                                    className={epicStyles.epicCardWrap}
                                >
                                    <div
                                        className={epicStyles.epicCard}
                                        style={{ cursor: 'default' }}
                                    >
                                        <Skeleton
                                            active
                                            title={{ width: '78%' }}
                                            paragraph={false}
                                            className={
                                                skStyles.epicTitleSkeleton
                                            }
                                        />
                                        <div
                                            className={
                                                epicStyles.epicCardFooter
                                            }
                                        >
                                            <Skeleton.Avatar
                                                active
                                                size={18}
                                                shape="square"
                                                className={
                                                    skStyles.epicFooterIconSk
                                                }
                                            />
                                            <Skeleton.Input
                                                active
                                                size="small"
                                                className={skStyles.epicKeySk}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>

            <div className={sectionStyles.sprintSection}>
                <div className={sectionStyles.sprintHeader}>
                    <div className={sectionStyles.sprintTitleRow}>
                        <Skeleton.Input
                            active
                            size="small"
                            className={skStyles.sprintTitleSkeleton}
                        />
                        <Skeleton.Button
                            active
                            size="small"
                            className={skStyles.sprintBadgeSkeleton}
                        />
                    </div>
                    <div className={sectionStyles.sprintHeaderActions}>
                        <Skeleton.Button
                            active
                            size="small"
                            className={skStyles.headerActionSkeleton}
                        />
                        <Skeleton.Button
                            active
                            size="small"
                            className={skStyles.headerActionSkeleton}
                        />
                    </div>
                </div>

                <div className={sectionStyles.sprintScrollRow}>
                    <div className={sectionStyles.sprintEpicScroll}>
                        <div
                            className={sectionStyles.sprintEpicGrid}
                            style={FOUR_COLUMN_GRID}
                        >
                            {Array.from({ length: TASK_LANE_COUNT }).map(
                                (_, i) => (
                                    <div
                                        key={i}
                                        className={sectionStyles.taskLane}
                                    >
                                        <div
                                            className={taskStyles.taskCardNew}
                                            style={{
                                                cursor: 'default',
                                                pointerEvents: 'none',
                                                padding: '8px 10px',
                                            }}
                                        >
                                            <div
                                                className={skStyles.taskTopRow}
                                            >
                                                <Skeleton.Avatar
                                                    active
                                                    size={16}
                                                    shape="square"
                                                    className={
                                                        skStyles.taskCheckSk
                                                    }
                                                />
                                                <div
                                                    className={
                                                        skStyles.taskTitleSkWrap
                                                    }
                                                >
                                                    <Skeleton
                                                        active
                                                        title={{
                                                            width: '72%',
                                                        }}
                                                        paragraph={false}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className={skStyles.taskMetaRow}
                                            >
                                                <Skeleton.Avatar
                                                    active
                                                    size={30}
                                                    shape="circle"
                                                    className={
                                                        skStyles.taskAssigneeSk
                                                    }
                                                />
                                                <Skeleton.Input
                                                    active
                                                    size="small"
                                                    className={
                                                        skStyles.taskDateSk
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className={
                                                sectionStyles.taskLaneAddSlot
                                            }
                                            aria-hidden
                                        />
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DevelopmentSprintBoardSkeleton
